import React, { FC } from 'react';
import styled from 'styled-components';
import media from '../../constants/media';
import theme from '../../constants/theme';
import { IMacroForm } from '../../interfaces/umbracoNodes/contentSlices';
import { ContentContainer } from '../base/contentContainer/contentContainer';
import { Column, Columns } from '../base/grid';
import { RichText } from '../base/richText/richText';
import RichTextTitle from '../base/richTextTitle';

const Root = styled.div`
	margin-top: 150px;
	font-family: ${theme.fonts.Arimo};
	font-size: 20px;
	line-height: 1.5;
	color: ${theme.colorsV2.mainDark};
`;

interface ColumnsStyledProps {
	fullWidth?: boolean;
}

const ColumnsStyled = styled(Columns)<ColumnsStyledProps>`
	${media.desktopSmall`
    justify-content: space-between;
    flex-direction: ${({ fullWidth }) => (fullWidth ? 'column' : 'row')};
    & > *:not(:last-child) {
      margin-bottom: ${({ fullWidth }) => (fullWidth ? '30px' : '0')};
    }
  `};
`;

const RichTextStyled = styled(RichText)`
	margin-block: 24px 64px;

	${media.desktopSmall`
		margin-block: 24px 0;
	`};
`;

const FormWrapper = styled.div``;

interface Props {
	content: IMacroForm;
}

const MacroForm: FC<Props> = ({ content }) => {
	return (
		<Root>
			<ContentContainer>
				<ColumnsStyled fullWidth={content.Values.FullWidth}>
					<Column desktopSmall={content.Values.FullWidth ? 1 : 5 / 12} marginBottom={0}>
						<RichTextTitle content={content.Values.Title} type="h3" />
						<RichTextStyled content={content.Values.Description} />
					</Column>
					<Column desktopSmall={content.Values.FullWidth ? 1 : 1 / 2} marginBottom={0}>
						<FormWrapper dangerouslySetInnerHTML={{ __html: content.Values.Form }}></FormWrapper>
					</Column>
				</ColumnsStyled>
			</ContentContainer>
		</Root>
	);
};

export default MacroForm;
